<template>
  <el-dialog
      :visible="dialogVisible"
      :close-on-click-modal="false"
      :title="wfconfigs.wfconfigID > 0 ? '编辑':'新建'"
      width="1000px"

      @close="$reset('form')">
    <el-form
        ref="form"
        :loading="contentLoading"
        :model="wfconfigs"
        label-width="100px">
      <div class="vm-separate" style="height:300px;">
        <el-row>
          <el-col :span="18">
            <el-form-item label="表单类型">
              <el-radio-group v-model="wfconfigs.billType" :disabled="wfconfigs.wfconfigID>0">
                <el-radio
                    v-for="(item,index) in wfconfigs.billTypeList"
                    :v-if="item.wfName"
                    :key="index"
                    style="margin-bottom: 1%"
                    :label="item.wfName"
                    @change="checkChange(item)">
                  {{item.formText}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="指定处理人" prop="handlerEmployeeName">
              <div style="display: flex;flex-direction: row;width: 300px;">
                <el-input v-model="wfconfigs.handlerEmployeeName" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectUser.open()"/>
                </el-input>
                <!--              <employee-select ref="selectEmployee" @select="onSelectEmployee"/>-->
                <user-select ref="selectUser" @select="selectUser"/>
              </div>
            </el-form-item>
            <el-form-item label="交货部门" prop="handlerValue">
              <div style="display: flex;flex-direction: row;width: 300px;">
                <el-input v-model="wfconfigs.handlerValue" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectMaterialType.open()"/>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <div>表单节点</div>
              <el-radio-group v-model="wfconfigs.approveNode" :disabled="wfconfigs.wfconfigID>0">
                <el-radio
                    v-for="(item,index) in wfconfigs.approveNodeList"
                    :key="index"
                    style="margin-top: 2%"
                    :label="item.approveNodeID"
                    @change="changeApproveNode(item)">
                  {{item.descrpt}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";

  export default {
    name: "WFConfigEdit",
    components: {UserSelect, MaterialTypeSelector},
    data() {
      return {
        billType: "",
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        wfconfigs: {
          approveNode: "",
          billType: "",
          handler: "",
          handlerEmployeeName: "",
          submitType: "",
          submitValue: "",
          wfconfigID: 0,
          submitList: [],
          handlerValue: "",
          billTypeList: [],
          approveNodeList: [],
        },
      };
    },
    methods: {
      open(id) {
        this.wfconfigs.wfconfigID = id;

        this.$nextTick(() => {
          this.getBillTypeList();
          if (id > 0) {
            this.getData();
          } else {
            // this.getWorkFlow("wfSaleOrderApplication");
            this.getInitData();
          }
        });
        this.dialogVisible = true;
        this.contentLoading = true;
      },

      getData() {
        this.$http
            .get("basic", `configs/${this.wfconfigs.wfconfigID}`)
            .then((resp) => {
              if (resp.success) {
                this.wfconfigs = resp.data;
                this.billType = this.wfconfigs.billType.replace(new RegExp("wf", "g"), "").replace(new RegExp("Application", "g"), "");
              }
            });
      },

      getInitData() {
        this.$http
            .get("basic", "configs/init")
            .then((resp) => {
              if (resp.success) {
                this.wfconfigs = resp.data;
                this.billType = this.wfconfigs.billType.replace(new RegExp("wf", "g"), "").replace(new RegExp("Application", "g"), "");
              }
            });
      },

      getBillTypeList() {
        this.$http.get("basic", "forms/selectList")
            .then((resp) => {
              if (resp.success) {
                this.billTypeList = resp.data;
              }
            });
      },
      checkChange(item) {
        console.log(item);
        this.wfconfigs.billType = item.wfName;
        this.wfconfigs.approveNodeList = item.nodeItems;
      },
      changeApproveNode(item) {
        this.wfconfigs.approveNode = item.approveNodeID;
        this.wfconfigs.approveNodeName = item.descrpt;
      },
      getWorkFlow(item) {
        let val = "";
        if (item.wfName === "") {
          val = "wf" + item.formName + "Application";
        } else {
          val = item.wfName;
        }
        this.$http
            .get("basic", `workflows/node/${val}`)
            .then((resp) => {
              if (resp.success) {
                this.approveNodeList = resp.data;
              }
            });
      },
      // getApproveNode(id) {
      //   this.$http
      //     .get("basic", `workflows/selectAllApproveNodes/${id}`)
      //     .then(resp => {
      //       this.approveNodeList = resp;
      //     });
      // },
      selectUser(row) {
        this.wfconfigs.handlerEmployeeName = row.employeeName;
        this.wfconfigs.handler = row.systemUserID;
      },

      // 物料类型选择
      selectMaterialType(row) {
        this.wfconfigs.submitType = 3;
        this.wfconfigs.handlerValue = row.name;
        this.wfconfigs.submitValue = row.id;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            let checkNodeErr = true;
            this.wfconfigs.approveNodeList.forEach((item) => {
              if (item.approveNodeID == this.wfconfigs.approveNode) {
                checkNodeErr = false;
              }
            });

            if (checkNodeErr) {
              this.$message.error("请选择当前表单类型节点");
              return;
            }
            this.$http
                .save("basic", "configs", this.wfconfigs)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$message.success("保存成功");
                  this.$emit("save-success");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

